import { postDataAccessExplainerExportStart } from '@api';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataSecurityAccessExplainerExportSlice = createPostAsyncSlice({
	name: 'CoreDataSecurityAccessExplainerExport',
	receive: true,
	request: true,
	requestHandler: postDataAccessExplainerExportStart,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Every
});
